import { render } from "./FormBuilderQuestionsView.vue?vue&type=template&id=c33284b0&scoped=true"
import script from "./FormBuilderQuestionsView.vue?vue&type=script&lang=js"
export * from "./FormBuilderQuestionsView.vue?vue&type=script&lang=js"

import "./FormBuilderQuestionsView.vue?vue&type=style&index=0&id=c33284b0&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c33284b0"]])

export default __exports__